import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts } from "@saleor/types";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import {
  createAutocompleteField,
  createOptionsField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum StoreDetailsFinanceFilterKeys {
  brand = "brand",
  mall = "mall",
  storeStatus = "storeStatus"
}

export interface StoreDetailsFinanceFilterOpts {
  brand: FilterOpts<string[]> & AutocompleteFilterOpts;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
  storeStatus: FilterOpts<string[]>;
}

const messages = defineMessages({
  active: {
    defaultMessage: "Active",
    description: "active status"
  },
  brand: {
    defaultMessage: "Brand",
    description: "brand"
  },
  declined: {
    defaultMessage: "Declined",
    description: "Declined status"
  },
  deleted: {
    defaultMessage: "Deleted",
    description: "Deleted status"
  },
  inactive: {
    defaultMessage: "Inactive",
    description: "inactive status"
  },
  mall: {
    defaultMessage: "Mall",
    description: "mall branch"
  },
  reviewed: {
    defaultMessage: "Reviewed",
    description: "Reviewed status"
  },
  storeStatus: {
    defaultMessage: "Store Status",
    description: "store status"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: StoreDetailsFinanceFilterOpts
): IFilter<StoreDetailsFinanceFilterKeys> {
  return [
    {
      ...createAutocompleteField(
        StoreDetailsFinanceFilterKeys.brand,
        intl.formatMessage(messages.brand),
        opts.brand.value,
        opts.brand.displayValues,
        true,
        opts.brand.choices,
        {
          hasMore: opts.brand.hasMore,
          initialSearch: "",
          loading: opts.brand.loading,
          onFetchMore: opts.brand.onFetchMore,
          onSearchChange: opts.brand.onSearchChange
        }
      ),
      active: opts.brand.active
    },
    {
      ...createAutocompleteField(
        StoreDetailsFinanceFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    },
    {
      ...createOptionsField(
        StoreDetailsFinanceFilterKeys.storeStatus,
        intl.formatMessage(messages.storeStatus),
        opts.storeStatus.value,
        true,
        [
          {
            label: intl.formatMessage(messages.active),
            value: SmopStatusEnum.ACT
          },
          {
            label: intl.formatMessage(messages.inactive),
            value: SmopStatusEnum.INA
          },
          {
            label: intl.formatMessage(messages.deleted),
            value: SmopStatusEnum.DEL
          },
          {
            label: intl.formatMessage(messages.reviewed),
            value: SmopStatusEnum.RVW
          },
          {
            label: intl.formatMessage(messages.declined),
            value: SmopStatusEnum.DCL
          }
        ]
      ),
      active: opts.storeStatus.active
    }
  ];
}
